<div id="login" fxLayout="column">
    <div class="custom-top-nav py-2">
        <img class="page-giant-logo border-1 mx-3" width="140" src="../../../../assets/images/logo/giant2.png">
    </div>
    <div class="company-info py-2 text-center"><h5 class="m-0">Giant Data Safe</h5></div>

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <!-- <div class="logo">
                <img src="../../../../assets/images/logo/giant2.png">
            </div> -->

            <label class="m-0" style="font-weight: 700; color: #000;"> Login to your account</label>
            <hr>

            <form name="loginForm" [formGroup]="loginForm" novalidate>
                <!-- <label>Username</label> -->
                <mat-form-field appearance="outline">
                    
                    <input matInput formControlName="username" placeholder="Username">
                    <mat-icon matSuffix class="secondary-text">person
                    </mat-icon>
                    <mat-error *ngIf="loginForm.get('username').hasError('required')">
                        Username is required
                    </mat-error>
                    <mat-error
                        *ngIf="!loginForm.get('username').hasError('required') &&
                                loginForm.get('username').hasError('username')">
                        Username is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <!-- <mat-label>Password</mat-label> -->
                    <input matInput type="password" formControlName="password" placeholder="Password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        Password is required
                    </mat-error>
                </mat-form-field>

                
                <button mat-raised-button class="submit-button" aria-label="Sign In" [disabled]="loginForm.invalid" (click)="onLogin(loginForm)" style="background-color: #36639f; color: #fff;; cursor: pointer; width: 100%; margin-bottom: 5px;">
                    LOGIN
                </button>
                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                     fxLayoutAlign="space-between center">
                    <!-- <mat-checkbox class="remember-me" aria-label="Remember Me">
                        Remember Me
                    </mat-checkbox> -->

                    <!-- <a class="forgot-password" [routerLink]="'/forgetpassword'" (click)="ForgetPassword()">
                        Forgot Password?
                    </a>
                    <br> -->
                    <p style="color:#33639f; cursor: pointer; width: 100%; text-align: right; font-size: 16px;"  (click)="ForgetPassword()">Forgot Password?</p>
                </div>
            </form>
        </div>
    </div>
</div>
